import {
  ID,
  ListApiResponse,
  SuccessApiResponse
} from '@ianesthesie-kit/services';
import axios, { AxiosResponse } from 'axios';
import { PremedicationOrder } from './premedication.model';
import { ListMedicalService, MedicalResponse } from '../baseMedical.service';

export class PremedicationService extends ListMedicalService<PremedicationOrder> {
  private static INSTANCE_BY_ID: PremedicationService;

  private constructor(patientId: string) {
    super('/premedication', patientId);
  }

  public static getInstance(patientId: ID): PremedicationService {
    if (this.shouldCreateNewInstance(this.INSTANCE_BY_ID, patientId)) {
      this.INSTANCE_BY_ID = new PremedicationService(patientId);
    }
    return this.INSTANCE_BY_ID;
  }

  public setNoPremedication(value: boolean): Promise<SuccessApiResponse> {
    return axios
      .put<SuccessApiResponse>(`${this.url}/no-premedication`, null, {
        params: { value }
      })
      .then((r) => r.data)
      .catch((err) => {
        throw this.unwrapErrorDetails(err) || err;
      });
  }

  public importFromProtocol(
    protocolId: ID
  ): Promise<MedicalResponse<PremedicationOrder, true>> {
    return axios
      .post(`${this.url}/import/${protocolId}`)
      .then((response: AxiosResponse<ListApiResponse<PremedicationOrder>>) => ({
        data: response.data.data.map((d) => this.transformResponseEntity(d))
      }))
      .catch((err) => {
        throw this.unwrapErrorDetails(err) || err;
      });
  }
}
